import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as APIHandler from "../../components/dashboard/FileManager/ApiHandler";
import { showSuccess } from "../../utils/showMessage";
import { act } from "react";
import FileSublist from "../../components/dashboard/FileManager/File/FileSublist/FileSublist";

const initialState = {
  copyFile: [],
  copyPath: null,
  isCopywithCtrlC: false,
  cutMethod: null,
  cutFile: [],
  cutPath: null,
  countInFolderUpload: 0,
  path: [],
  errorCode: null,
  DragUploadVisibleDialog: false,
  pathSublist: [],
  totalUploads: 0,
  completedUploads: 0,
  copyConflictFiles: [],
  copyShowConflictDialog: false,
  moveConflictFiles: [],
  moveShowConflictDialog: false,
  viewMode: "large",
  fileList: [],
  CopyFileList: [],
  fileListSublist: [],
  DragDropFiles: [],
  fileListFilter: "",
  uploadMethod: "",
  contextMenuVisible: false,
  atRoot: false,
  contextMenuPosition: { x: 0, y: 0 },
  contextMenuPositionElement: null,
  selectedFiles: [],
  selectedFolderSublist: [],
  fileUploadProgress: 0,
  folderUploadProgress: -1,
  loading: false,
  loadingSublist: false,
  errorMsg: "",
  visibleDialogCreateFolder: false,
  visibleDialogUploadFile: false,
  visibleDialogUploadFolder: false,
  visibleDialogContent: false,
  visibleDialogEdit: false,
  visibleDialogMove: false,
  visibleDialogCopy: false,
  visibleRenamefield: false,
  visibleDialogRename: false,
  visibleDialogDelete: false,
  visibleDialogBackgroundActions: false,
  showProgressContainer: false,
  fileUploadList: [],
  folderUploadList: [],
  fileTransferUploadList: [],
  unzipItemsList: [],
  forwardStack: [],
  backStack: [],
  zipItemsList: [],
  copyItemsList: [],
  moveItemsList: [],
  removeItemsList: [],
  fileDownloadList: [],
  fileContentBlobUrl: null,
  sublistEntriesPath: [],
  activeUploads: {},
  sortField: localStorage.getItem("fm_sortField") || "name",
  sortOrder: localStorage.getItem("fm_sortOrder") || "asc",
};

export const uploadFiles = createAsyncThunk(
  "files/uploadFiles",
  async (fileList, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    dispatch(setLoading(true));
    dispatch(setSelectedFiles([]));
    dispatch(setFileUploadProgress(50));
    const { data, error } = await APIHandler.uploadFiles(
      path.join("/"),
      fileList
    );
    if (data !== null) {
      dispatch(setFileUploadProgress(100));
      setTimeout((f) => {
        dispatch(resetFileUploader());
      }, 300);
      dispatch(refreshFileList());
    }
    if (error !== null) {
      dispatch(setErrorMsg(error.message.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const refreshFileList = createAsyncThunk(
  "files/refreshFileList",
  async (_, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;

    dispatch(setLoading(true));
    dispatch(setFileList([]));
    dispatch(setSelectedFiles([]));

    try {
      const { data, error, statusCode } = await APIHandler.getFileList(path.join("/"));
      if (data) {
        dispatch(setFileList(data));
        dispatch(setErrorCode(null));
        dispatch(setErrorMsg(null));
        return;
      }

      const code = error?.error_code || statusCode || 500;
      dispatch(setErrorCode(code));

      if (code === 400 && !error?.error_code) {
        dispatch(setErrorMsg("You don't have access to this folder, Premission denied"));
      } else {
        // Pass the structured error object or a fallback string
        dispatch(setErrorMsg(error?.error_message || error?.message || error || "Unknown error"));
      }

      dispatch(setFileList([]));

    } catch (err) {
      dispatch(setErrorCode(500));
      dispatch(setErrorMsg("Something went wrong, please try again."));
      dispatch(setFileList([]));

    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const refreshSublistEntries = createAsyncThunk(
  "files/refreshFileListSublist",
  async (folderPath, { dispatch, getState }) => {
    try {
      const state = getState();

      dispatch(setLoadingSublist(true));
      dispatch(setSelectedFolderSublist(null));
      const { pathSublist, path } = state.fileManager;
      const basePath =
        !pathSublist || pathSublist.length === 0
          ? path.join("/")
          : pathSublist.join("/");

      const extraPath = Array.isArray(folderPath)
        ? folderPath.join("/")
        : folderPath || "";

      const fullPath = extraPath ? `${basePath}/${extraPath}` : basePath;
      const { data, error } = await APIHandler.getFileList(fullPath);

      if (data !== null) {
        dispatch(setSublistEntries(data));
        dispatch(setLoadingSublist(false));
        return data;
      }

      dispatch(setSublistEntries([]));
      dispatch(setErrorMsg(error?.message?.toString() || "Unknown error"));
      dispatch(setLoadingSublist(false));
      return [];
    } catch (err) {
      dispatch(setSublistEntries([]));
      dispatch(setErrorMsg(err.message));
      dispatch(setLoadingSublist(false));
      return [];
    }
  }
);

export const refreshFileListSublist = createAsyncThunk(
  "files/refreshFileListSublist",
  async (_, { dispatch, getState }) => {
    const state = getState();
    const { pathSublist } = state.fileManager;
    dispatch(setLoadingSublist(true));
    dispatch(setSelectedFolderSublist(null));
    const { data, error } = await APIHandler.getFileList(pathSublist.join("/"));
    if (data !== null) {
      dispatch(setLoadingSublist(false));
      dispatch(setFileListSublist(data));
      dispatch(setSublistEntries(data));
    } else {
      dispatch(setFileListSublist([]));
      dispatch(setSublistEntries([]))
      dispatch(setErrorMsg(error.message.toString()));

      dispatch(setLoadingSublist(false));
    }
  }
);
export const getFileContent = createAsyncThunk(
  "files/getFileContent",
  async (fileName, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    dispatch(setLoading(true));
    dispatch(setFileContent(null));
    dispatch(setVisibleDialogContent(true));
    const { data, error } = await APIHandler.getFileBody(
      path.join("/"),
      fileName
    );
    if (data !== null) {
      dispatch(setFileContent(data));
      dispatch(setLoading(false));
    } else {
      dispatch(setErrorMsg(error.message.toString()));

      dispatch(setLoading(false));
    }
  }
);
export const renameItem = createAsyncThunk(
  "files/renameItem",
  async ({ fileName, newFileName, overwrite = false }, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    dispatch(setLoading(true));
    const { data, error } = await APIHandler.renameItem(
      path.join("/"),
      fileName,
      newFileName,
      overwrite
    );
    if (data !== null) {
      dispatch(setLoading(false));
      dispatch(refreshFileList());
      showSuccess(
        "File" + " " + fileName + " " + "Renamed to" + " " + newFileName
      );
    } else {
      dispatch(setErrorMsg(error.message.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const downloadFile = createAsyncThunk(
  "files/downloadFile",
  async (fileName, { dispatch, getState }) => {
    try {
      const state = getState();
      const { path } = state.fileManager;
      dispatch(setLoading(true));
      const { data, error } = await APIHandler.getFileDownload(
        path.join("/"),
        fileName
      );
      if (data instanceof Blob) {
        const blobUrl = window.URL.createObjectURL(data);
        const tempLink = document.createElement("a");
        tempLink.href = blobUrl;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        window.URL.revokeObjectURL(blobUrl);
        dispatch(setLoading(false));
      } else {
        throw new Error(error || "Failed to download file.");
      }
    } catch (error) {
      dispatch(setErrorMsg(error.message || "Failed to download file."));
      dispatch(setLoading(false));
    }
  }
);
/**
 * Request API to get file content then dispatch defined events
 * @param {String} fileName
 */
export const getFileContentForEdit = createAsyncThunk(
  "files/getFileContentForEdit",
  async (fileName, { dispatch, getState }) => {
    const { path } = getState();
    dispatch(setLoading(true));
    dispatch(setFileContent(null));
    dispatch(setVisibleDialogEdit(true));
    const { data, error } = await APIHandler.getFileBody(
      path.join("/"),
      fileName
    );
    if (data !== null) {
      dispatch(setFileContent(data));
      dispatch(setLoading(false));
    } else {
      dispatch(setErrorMsg(error.message.toString()));
      dispatch(setLoading(false));
    }
  }
);

/**
 * Request API to create a folder then dispatch defined events
 * @param {String} createFolderName
 */
export const createNewFolder = createAsyncThunk(
  "files/createNewFolder",
  async (createFolderName, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    dispatch(setVisibleDialogCreateFolder(false));

    const { data, error } = await APIHandler.createFolder(
      path.join("/"),
      createFolderName
    );
    if (data !== null) {
      dispatch(setLoading(false));
      dispatch(refreshFileList());
      showSuccess(createFolderName + " Created");
    } else {
      dispatch(setErrorMsg(error.message.toString()));
      dispatch(setLoading(false));
    }
  }
);

/**
 * Request API to remove an item then dispatch defined events
 * @param {Array} filenames
 */
export const removeItems = createAsyncThunk(
  "files/removeItems",
  async (files, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    const filenames = files.map((f) => f.name);

    const markFiles = (typeValue, receivedValue, totalValue, progressValue, errorMessage = null) => {
      files.forEach((file) => {
        dispatch(
          setRemoveItemsList({
            type: typeValue,
            file_name: file.name,
            received: receivedValue,
            total: totalValue,
            progress: progressValue,
            error: errorMessage,
          })
        );
      });
    };

    try {
      const { data, error } = await APIHandler.removeItems(path.join("/"), filenames);

      if (data?.status === "success") {
        markFiles("complete", "100", "processing", "100");
        dispatch(refreshFileList());
        showSuccess("Item Deleted");
        return;
      }

      markFiles("error", "0", "Error", "0", "Permission Denied");

    } catch (err) {
      markFiles("error", "0", "Error", "0", err.message || "Something went wrong");
    }
  }
);

export const zipFileOrFolder = createAsyncThunk(
  "files/zipFileOrFolder",
  async (files, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    const filenames = files.map((f) => f.name);
    const { data, error } = await APIHandler.zipFileOrFolder(
      path.join("/"),
      filenames
    );
    if (data !== null) {
      if (data.status == "success") {
        data.filenames.forEach((item) => {
          dispatch(
            setZipItemsList({
              type: "complete",
              file_name: item,
              received: "100",
              total: "processing",
              progress: "100",
            })
          );
        });
        dispatch(setLoading(false));
        dispatch(refreshFileList());
        showSuccess("Item Ziped");
      }
    } else {
      files.forEach((f) => {
        dispatch(
          setZipItemsList({
            type: "error",
            file_name: f.name,
            received: "0",
            total: "Error",
            progress: "100",
          })
        );
      });
      dispatch(setErrorMsg(error.message.toString()));
      dispatch(setLoading(false));
      dispatch(setZipItemsList({ updatedZipItemsList: [], action: "remove" }));
    }
  }
);

export const UnZipFile = createAsyncThunk(
  "files/UnZipFile",
  async (files, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    const filenames = files.map((f) => f.name);

    const { data, error } = await APIHandler.UnZipFile(
      path.join("/"),
      filenames
    );
    if (data !== null) {
      if (data.status == "success") {
        data.filenames.forEach((item) => {
          dispatch(
            setUnzipItemsList({
              type: "complete",
              file_name: item,
              received: "100",
              total: "processing",
              progress: "100",
            })
          );
        });
        dispatch(setLoading(false));
        dispatch(refreshFileList());
        showSuccess("Item Unziped");
      }
    } else {
      dispatch(setErrorMsg(error.message.toString()));
      dispatch(setLoading(false));
      // Clear unzip items from progress list when there's an error
      dispatch(setUnzipItemsList({ updatedUnzipItemsList: [], action: "remove" }));
    }
  }
);

/**
 * Request API to move an item then dispatch defined events
 * @param {Array} filenames
 */
export const moveItems = createAsyncThunk(
  "files/moveItems",
  async ({ files, saveAsMap }, { dispatch, getState }) => {
    const state = getState();
    const { path, pathSublist, selectedFolderSublist } = state.fileManager;
    const sublistPath = pathSublist.join("/");
    const destination =
      sublistPath +
      (sublistPath.endsWith("/") ? "" : "/") +
      (selectedFolderSublist?.name || "");

    const filenames = files.map((f) => f.name);

    const { data, error } = await APIHandler.moveItems(
      path.join("/"),
      destination,
      filenames,
      saveAsMap
    );


    if (data !== null && data.status === "success") {
      data.filenames.forEach((item) => {
        dispatch(
          setMoveItemsList({
            type: "complete",
            file_name: item,
            received: "100",
            total: "processing",
            progress: "100",
          })
        );
      });
      dispatch(setLoading(false));
      dispatch(setVisibleDialogMove(false));
      dispatch(refreshFileList());
      showSuccess("Item Moved");
    } else {
      files.forEach((f) => {
        dispatch(
          setMoveItemsList({
            type: "error",
            file_name: saveAsMap[f.name] || f.name,
            progress: 0,
          })
        );
      });
      dispatch(setLoading(false));
    }
  }
);

export const moveItemsCtrlx = createAsyncThunk(
  "files/moveItemsCtrlx",
  async ({ files, saveAsMap }, { dispatch, getState }) => {
    const state = getState();
    const { path, cutPath } = state.fileManager;

    const destination = path.join("/");
    const source = cutPath.join("/");
    const filenames = files.map((f) => f.name);

    const { data, error } = await APIHandler.moveItems(
      source,
      destination,
      filenames,
      saveAsMap
    );

    dispatch(setCut({ files: [], path: [] }));
    dispatch(setisCutwithCtrlC(null));

    if (data?.status === "success") {
      data.filenames.forEach((item) => {
        dispatch(
          setMoveItemsList({
            type: "complete",
            file_name: item,
            received: "100",
            total: "processing",
            progress: "100",
          })
        );
      });

      dispatch(setLoading(false));
      dispatch(setVisibleDialogMove(false));
      dispatch(refreshFileList());
      showSuccess("Files moved");
      return;
    }
    files.forEach((f) => {
      dispatch(
        setMoveItemsList({
          type: "error",
          file_name: saveAsMap[f.name] || f.name,
          received: "0",
          total: "Error",
          progress: "0",
        })
      );
    });

    dispatch(setLoading(false));
  }
);


export const dragMoveItem = createAsyncThunk(
  "files/dragMoveItem",
  async ({ files, saveAsMap }, { dispatch, getState }) => {
    try {
      const state = getState();
      const { path, cutPath } = state.fileManager;

      const sourcePath = Array.isArray(path) ? path.join("/") : path;
      const destPath = Array.isArray(cutPath) ? cutPath.join("/") : cutPath;

      const source = sourcePath.replace(/\/+$/, "");
      const destination = destPath.replace(/\/+$/, "");
      const filenames = files.map((f) => f.name);

      const { data, error } = await APIHandler.moveItems(
        source,
        destination,
        filenames,
        saveAsMap
      );

      if (data?.status === "success") {
        data.filenames.forEach((item) => {
          dispatch(
            setMoveItemsList({
              type: "complete",
              file_name: item,
              received: "100",
              total: "processing",
              progress: "100",
            })
          );
        });

        dispatch(setLoading(false));
        dispatch(setVisibleDialogMove(false));
        dispatch(refreshFileList());
        showSuccess("Files moved");
        return;
      }
      files.forEach((f) => {
        dispatch(
          setMoveItemsList({
            type: "error",
            file_name: saveAsMap[f.name] || f.name,
            received: "0",
            total: "Error",
            progress: "0",
          })
        );
      });

      dispatch(setLoading(false));

    } catch (err) {
      showSuccess("dragMoveItem failed:" + err.message);
    }
  }
);


/**
 * Request API to copy an item then dispatch defined events
 * @param {Array} filenames
 */
export const copyItems = createAsyncThunk(
  "files/copyItems",
  async ({ files, saveAsMap }, { dispatch, getState }) => {
    const state = getState();
    const { path, pathSublist, selectedFolderSublist } = state.fileManager;

    const basePath = pathSublist.join("/");
    const destination =
      basePath +
      (basePath.endsWith("/") ? "" : "/") +
      (selectedFolderSublist?.name || "");

    const filenames = files.map((f) => f.name);

    const { data, error } = await APIHandler.copyItems(
      path.join("/"),
      destination,
      filenames,
      saveAsMap
    );

    if (data?.status === "success") {
      data.filenames.forEach((item) => {
        dispatch(
          setCopyItemsList({
            type: "complete",
            file_name: item,
            received: "100",
            total: "processing",
            progress: "100",
          })
        );
      });

      dispatch(setLoading(false));
      dispatch(setVisibleDialogCopy(false));
      dispatch(refreshFileList());
      showSuccess("Item Copied");
      return;
    }

    files.forEach((f) => {
      dispatch(
        setCopyItemsList({
          type: "error",
          file_name: saveAsMap[f.name] || f.name,
          received: "0",
          total: "Error",
          progress: "0",
        })
      );
    });

    dispatch(setLoading(false));
  }
);


export const copyItemsCtrlc = createAsyncThunk(
  "files/copyItems",
  async ({ files, saveAsMap }, { dispatch, getState }) => {
    const state = getState();
    const { path, copyPath } = state.fileManager;

    const source = copyPath.join("/").replace(/\/+$/, "");
    const destination = path.join("/").replace(/\/+$/, "");
    const filenames = files.map((f) => f.name);

    const { data, error } = await APIHandler.copyItems(
      source,
      destination,
      filenames,
      saveAsMap
    );

    if (data?.status === "success") {
      data.filenames.forEach((item) => {
        dispatch(
          setCopyItemsList({
            type: "complete",
            file_name: item,
            received: "100",
            total: "processing",
            progress: "100",
          })
        );
      });

      dispatch(setLoading(false));
      dispatch(setVisibleDialogCopy(false));
      dispatch(refreshFileList());
      showSuccess("Files copied");
      return;
    }

    files.forEach((f) => {
      dispatch(
        setCopyItemsList({
          type: "error",
          file_name: saveAsMap[f.name] || f.name,
          received: "0",
          total: "Error",
          progress: "0",
        })
      );
    });

    dispatch(setisCopywithCtrlC(false));
    dispatch(setLoading(false));
    dispatch(setCopy({ files: [], path: [] }));
  }
);

/**
 * This handles multiple selection by using shift key
 * @param {Object} lastFile
 */
export const setSelectedFileFromLastTo = createAsyncThunk(
  "files/setSelectedFileFromLastTo",
  (lastFile, { dispatch, getState }) => {
    const { fileList, selectedFiles } = getState();

    const lastPreviouslySelected = [...selectedFiles].pop();
    const lastPreviouslySelectedIndex = fileList.indexOf(
      fileList.find((f) => f.name === lastPreviouslySelected.name)
    );
    const lastSelectedIndex = fileList.indexOf(
      fileList.find((f) => f.name === lastFile.name)
    );

    let toAdd = [];
    if (lastSelectedIndex > lastPreviouslySelectedIndex) {
      toAdd = fileList.filter((index, element) => {
        return (
          fileList.indexOf(index) <= lastSelectedIndex &&
          fileList.indexOf(index) >= lastPreviouslySelectedIndex
        );
      });
    } else {
      toAdd = fileList.filter((index, element) => {
        return (
          fileList.indexOf(index) >= lastSelectedIndex &&
          fileList.indexOf(index) <= lastPreviouslySelectedIndex
        );
      });
    }
    dispatch(setSelectedFiles([...selectedFiles, ...toAdd]));
  }
);

/**
 * @returns {Function}
 */
export const initSubList = createAsyncThunk(
  "files/initSubList",
  (_, { dispatch, getState }) => {
    const state = getState();
    const { path } = state.fileManager;
    dispatch(setSelectedFolderSublist(null));
    dispatch(setFileListSublist([]));
    dispatch(setSublistEntries([]));
    dispatch(setPathSublist([...path]));
    dispatch(refreshFileListSublist());
  }
);

export const resetFileUploader = createAsyncThunk(
  "files/resetFileUploader",
  (_, { dispatch, getState }) => {
    dispatch(setFileUploadProgress(0));
    dispatch(setVisibleDialogUploadFile(false));
    dispatch(setFileUploadList([]));
  }
);

export const resetFolderUploader = createAsyncThunk(
  "files/resetFileUploader",
  (_, { dispatch, getState }) => {
    dispatch(setFolderUploadList([]));
  }
);

export const enterToPreviousDirectory = createAsyncThunk(
  "files/enterToPreviousDirectory",
  (_, { dispatch, getState }) => {
    const { path, backStack, forwardStack } = getState().fileManager;

    if (backStack.length > 0) {
      dispatch(setForwardStack([path, ...forwardStack]));
      const newBackStack = [...backStack];
      const newPath = newBackStack.pop();
      dispatch(setBackStack(newBackStack));
      dispatch(setPath(newPath));
      dispatch(setFileListFilter(null));
      dispatch(refreshFileList());
    }
  }
);

export const goForward = createAsyncThunk(
  "files/goForward",
  (_, { dispatch, getState }) => {
    const { path, forwardStack, backStack } = getState().fileManager;

    if (forwardStack.length > 0) {
      const [next, ...restForward] = forwardStack;
      dispatch(setBackStack([...backStack, path]));
      dispatch(setForwardStack(restForward));
      dispatch(setPath(next));
      dispatch(refreshFileList());
    }
  }
);

export const enterToPreviousDirectoryByIndex = createAsyncThunk(
  "files/enterToPreviousDirectoryByIndex",
  (index, { dispatch, getState }) => {
    const { path, backStack } = getState().fileManager;

    const newPath = path.slice(0, index + 1);

    dispatch(setForwardStack([]));

    dispatch(setBackStack([...backStack, path]));

    dispatch(setPath(newPath));
    dispatch(refreshFileList());
    dispatch(setFileListFilter(null));
  }
);



export const enterToPreviousDirectorySublist = createAsyncThunk(
  "files/enterToPreviousDirectorySublist",
  (_, { dispatch, getState }) => {
    const state = getState();
    const { pathSublist } = state.fileManager;
    dispatch(setPathSublist(pathSublist.slice(0, -1)));
    dispatch(refreshFileListSublist());
  }
);

export const rightClickOnFile = createAsyncThunk(
  "files/rightClickOnFile",
  (file, { dispatch, getState }) => {
    const { selectedFiles } = getState().fileManager;
    const isSelected = selectedFiles.some((f) => f.name === file.name);
    if (!isSelected) {
      dispatch(setSelectedFiles([file]));
    }
  }
);

const fileManagerSlice = createSlice({
  name: "fileManager",
  initialState,
  reducers: {
    setCopy: (state, action) => {
      state.copyFile = action.payload.files;
      state.copyPath = action.payload.path;
      state.cutFile = null;
      state.cutPath = null;
    },
    setCut: (state, action) => {
      state.cutFile = action.payload.files;
      state.cutPath = action.payload.path;
      state.copyFile = null;
      state.copyPath = null;
    },
    setPath(state, action) {
      state.path = action.payload;
      if (state.path.length === 0) {
        state.atRoot = false;
      } else {
        state.atRoot = true;
      }
    },
    setDragDropFiles(state, action) {
      state.DragDropFiles = action.payload;
    },
    setPathSublist(state, action) {
      state.pathSublist = action.payload;
    },
    enterToDirectory(state, action) {
      state.path.push(action.payload);
      if (state.path.length === 0) {
        state.atRoot = false;
      } else {
        state.atRoot = true;
      }
    },
    enterToDirectorySublist(state, action) {
      state.pathSublist.push(action.payload);
    },
    setFileList(state, action) {
      state.fileList = action.payload.sort((a, b) =>
        a.type < b.type ? -1 : a.name.toLowerCase() > b.name.toLowerCase()
      );
    },
    setViewMode: (state, action) => {
      state.viewMode = action.payload;
    },
    setCopyFileList(state, action) {
      state.CopyFileList = action.payload.sort((a, b) =>
        a.type < b.type ? -1 : a.name.toLowerCase() > b.name.toLowerCase()
      );
    },
    setFileListSublist(state, action) {
      state.fileListSublist = action.payload.sort((a, b) =>
        a.type < b.type ? -1 : a.name.toLowerCase() > b.name.toLowerCase()
      );
    },
    setSublistEntries(state, action) {
      state.sublistEntries = action.payload;
    },
    setisCopywithCtrlC(state, action) {
      state.isCopywithCtrlC = action.payload;
    },
    setisCutwithCtrlC(state, action) {
      state.cutMethod = action.payload;
    },
    setFileListFilter(state, action) {
      state.fileListFilter = action.payload;
    },
    setDragUploadVisibleDialog(state, action) {
      state.DragUploadVisibleDialog = action.payload;
    },
    setContextMenuVisible(state, action) {
      state.contextMenuVisible = action.payload;
    },
    setContextMenuPosition(state, action) {
      const { x, y } = action.payload;
      state.contextMenuPosition = { x, y };
    },
    setContextMenuPositionElement(state, action) {
      state.contextMenuPositionElement = action.payload;
    },
    setVisibleDialogBackgroundActions(state, action) {
      state.visibleDialogBackgroundActions = action.payload;
    },
    setBackStack(state, action) {
      state.backStack = action.payload;
    },
    setTotalUploads: (state, action) => {
      state.totalUploads += action.payload;
    },
    resetCompletedUploads: (state) => {
      state.completedUploads = 0;
    },
    resetTotalUploads: (state) => {
      state.totalUploads = 0;
      state.totalUploads = 0;
    },
    decrementTotalUploads: (state, action) => {
      state.totalUploads = Math.max(0, state.totalUploads - action.payload);
    },
    setCompletedUploads: (state, action) => {
      state.completedUploads = action.payload;
    },
    setCopyConflictDialogVisible: (state, action) => {
      state.copyShowConflictDialog = true;
      state.copyConflictFiles = action.payload.files || [];
    },
    clearCopyConflictDialog: (state) => {
      state.copyShowConflictDialog = false;
      state.copyConflictFiles = [];
    },
    setMoveConflictDialogVisible: (state, action) => {
      state.moveShowConflictDialog = true;
      state.moveConflictFiles = action.payload.files || [];
    },
    clearMoveConflictDialog: (state) => {
      state.moveShowConflictDialog = false;
      state.moveConflictFiles = [];
    },
    incrementCompletedUploads: (state) => {
      state.completedUploads += 1;
    },
    resetUploads: (state) => {
      state.totalUploads = 0;
      state.completedUploads = 0;
    },
    setForwardStack(state, action) {
      state.forwardStack = action.payload;
    },
    setSelectedFiles(state, action) {
      state.selectedFiles = action.payload.filter(
        (f, i, self) => self.map((ff) => ff.name).indexOf(f.name) === i
      );
    },
    setSelectedFolderSublist(state, action) {
      state.selectedFolderSublist = action.payload;
    },
    setErrorCode: (state, action) => {
      state.errorCode = action.payload;
    },
    toggleSelectedFile(state, action) {
      const index = state.selectedFiles.findIndex(
        (f) => f.name === action.payload.name
      );
      if (index >= 0) {
        state.selectedFiles.splice(index, 1);
      } else {
        state.selectedFiles.push(action.payload);
      }
    },
    setFileUploadProgress(state, action) {
      state.fileUploadProgress = parseInt(action.payload || 0);
    },
    setFolderUploadProgress(state, action) {
      state.folderUploadProgress = parseFloat(action.payload || 0);
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setLoadingSublist(state, action) {
      state.loadingSublist = action.payload;
    },
    setErrorMsg(state, action) {
      state.errorMsg = action.payload;
    },
    setVisibleDialogCreateFolder(state, action) {
      state.visibleDialogCreateFolder = !!action.payload;
    },
    setVisibleDialogUploadFile(state, action) {
      state.visibleDialogUploadFile = !!action.payload;
    },
    setVisibleDialogUploadFolder(state, action) {
      state.visibleDialogUploadFolder = !!action.payload;
    },
    setVisibleDialogContent(state, action) {
      state.visibleDialogContent = !!action.payload;
    },
    setVisibleDialogEdit(state, action) {
      state.visibleDialogEdit = !!action.payload;
    },
    setVisibleDialogRename: (state, action) => {
      state.visibleDialogRename = action.payload;
    },
    setVisibleDialogDelete: (state, action) => {
      state.visibleDialogDelete = action.payload;
    },
    setVisibleDialogBackgroundActions: (state, action) => {
      state.visibleDialogBackgroundActions = !!action.payload;
    },
    setVisibleDialogMove(state, action) {
      state.visibleDialogMove = !!action.payload;
    },
    setVisibleDialogCopy(state, action) {
      state.visibleDialogCopy = !!action.payload;
    },
    setVisibleDialogRename(state, action) {
      state.visibleRenamefield = action.payload;
    },
    setsublistEntriesPath(state, action) {
      state.sublistEntriesPath = action.payload;
    },
    setFileUploadList(state, action) {
      state.fileUploadList = action.payload;
    },
    setFolderUploadList(state, action) {
      state.folderUploadList = action.payload;
    },
    setShowProgressContainer(state, action) {
      state.showProgressContainer = action.payload;
    },
    setcountInFolderUpload(state, action) {
      state.countInFolderUpload = action.payload;
    },
    setZipItemsList(state, action) {
      let updatedList;
      if (action.payload.action === "remove") {
        updatedList = action.payload.updatedZipItemsList;
      } else {
        updatedList = state.zipItemsList.map((file) =>
          file.file_name === action.payload.file_name ? action.payload : file
        );

        if (
          !updatedList.find(
            (file) => file.file_name === action.payload.file_name
          )
        ) {
          updatedList.push(action.payload);
        }
      }
      state.zipItemsList = updatedList;
    },
    setUnzipItemsList(state, action) {
      let updatedList;
      if (action.payload.action === "remove") {
        updatedList = action.payload.updatedUnzipItemsList;
      } else {
        updatedList = state.unzipItemsList.map((file) =>
          file.file_name === action.payload.file_name ? action.payload : file
        );

        if (
          !updatedList.find(
            (file) => file.file_name === action.payload.file_name
          )
        ) {
          updatedList.push(action.payload);
        }
      }
      state.unzipItemsList = updatedList;
    },
    setCopyItemsList(state, action) {
      let updatedList; // Use let instead of const to allow reassignment
      if (action.payload.action === "remove") {
        updatedList = action.payload.updatedCopyItemsList;
      } else {
        updatedList = state.copyItemsList.map((file) =>
          file.file_name === action.payload.file_name ? action.payload : file
        );

        // Add the new file if it doesn't already exist in the list
        if (
          !updatedList.find(
            (file) => file.file_name === action.payload.file_name
          )
        ) {
          updatedList.push(action.payload);
        }
      }
      state.copyItemsList = updatedList;
    },
    setMoveItemsList(state, action) {
      let updatedList; // Use let instead of const to allow reassignment

      if (action.payload.action === "remove") {
        updatedList = action.payload.updatedMoveItemsList;
      } else {
        updatedList = state.moveItemsList.map((file) =>
          file.file_name === action.payload.file_name ? action.payload : file
        );
        if (
          !updatedList.find(
            (file) => file.file_name === action.payload.file_name
          )
        ) {
          updatedList.push(action.payload);
        }
      }
      state.moveItemsList = updatedList;
    },
    setFileTranferUploadList(state, action) {
      let updatedList;

      if (action.payload.action === "remove") {
        if (action.payload.updatedFileUploadList) {
          updatedList = action.payload.updatedFileUploadList;
        } else if (action.payload.file_name) {
          // Remove the specific file by name
          updatedList = state.fileTransferUploadList.filter(
            (file) => file.file_name !== action.payload.file_name
          );
        } else {
          updatedList = [];
        }
      } else {
        updatedList = state.fileTransferUploadList.map((file) =>
          file.file_name === action.payload.file_name ? action.payload : file
        );

        // Add the new file if it doesn't already exist in the list
        if (
          !updatedList.find(
            (file) => file.file_name === action.payload.file_name
          )
        ) {
          updatedList.push(action.payload);
        }
      }

      // Update the state immediately
      state.fileTransferUploadList = updatedList;
    },
    setRemoveItemsList(state, action) {
      let updatedList;

      if (action.payload.action === "remove") {
        updatedList = action.payload.updatedRemoveItemsList;
      } else {
        updatedList = state.removeItemsList.map((file) =>
          file.file_name === action.payload.file_name ? action.payload : file
        );

        if (
          !updatedList.find(
            (file) => file.file_name === action.payload.file_name
          )
        ) {
          updatedList.push(action.payload);
        }
      }
      state.removeItemsList = updatedList;
    },

    setFileDownloadList(state, action) {
      let updatedList;
      if (action.payload.action === "remove") {
        updatedList = action.payload.updatedFileDownloadList;
      } else if (action.payload.action === "failed") {
        updatedList = state.fileDownloadList.filter(
          (file) => file.file_name !== action.payload.file_name
        );
      } else {
        updatedList = state.fileDownloadList.map((file) =>
          file.file_name === action.payload.file_name ? action.payload : file
        );

        // Add the new file if it doesn't already exist in the list
        if (
          !updatedList.find(
            (file) => file.file_name === action.payload.file_name
          )
        ) {
          updatedList.push(action.payload);
        }
      }

      state.fileDownloadList = updatedList;
    },

    setFileContent(state, action) {
      if (state.fileContentBlobUrl) {
        URL.revokeObjectURL(state.fileContentBlobUrl);
      }
      state.fileContentBlobUrl = action.payload
        ? URL.createObjectURL(action.payload)
        : null;
    },
    setSortField(state, action) {
      state.sortField = action.payload;
      localStorage.setItem("fm_sortField", action.payload);
    },
    setSortOrder(state, action) {
      state.sortOrder = action.payload;
      localStorage.setItem("fm_sortOrder", action.payload);
    },
    registerActiveUpload: (state, action) => {
      const { unique_id, controller, filename, path } = action.payload;
      state.activeUploads[unique_id] = { controller, filename, path };
    },
    removeActiveUpload: (state, action) => {
      const { unique_id } = action.payload;
      if (state.activeUploads[unique_id]) {
        delete state.activeUploads[unique_id];
      }
    },
  },
});

export const {
  setCopy,
  setCut,
  setPath,
  setPathSublist,
  enterToDirectory,
  enterToDirectorySublist,
  setFileList,
  setFileListSublist,
  setCopyFileList,
  setFileListFilter,
  setContextMenuVisible,
  setContextMenuPosition,
  setContextMenuPositionElement,
  setSelectedFiles,
  setSelectedFolderSublist,
  toggleSelectedFile,
  setFileUploadProgress,
  setFolderUploadProgress,
  setErrorCode,
  setBackStack,
  setForwardStack,
  setTotalUploads,
  setCompletedUploads,
  incrementCompletedUploads,
  resetUploads,
  decrementTotalUploads,
  resetTotalUploads,
  resetCompletedUploads,
  setDragUploadVisibleDialog,
  setLoading,
  setLoadingSublist,
  setErrorMsg,
  setVisibleDialogCreateFolder,
  setVisibleDialogUploadFile,
  setVisibleDialogUploadFolder,
  setDragDropFiles,
  setVisibleDialogContent,
  setVisibleDialogEdit,
  setVisibleDialogMove,
  setVisibleDialogCopy,
  setVisibleDialogRename,
  setVisibleDialogDelete,
  setVisibleDialogBackgroundActions,
  setZipItemsList,
  setViewMode,
  setCopyConflictDialogVisible,
  clearCopyConflictDialog,
  setMoveConflictDialogVisible,
  clearMoveConflictDialog,
  setisCopywithCtrlC,
  setisCutwithCtrlC,
  setsublistEntriesPath,
  setUnzipItemsList,
  setCopyItemsList,
  setMoveItemsList,
  setFileUploadList,
  setSublistEntries,
  setFolderUploadList,
  setFileTranferUploadList,
  setcountInFolderUpload,
  setFileDownloadList,
  setFileContent,
  setShowProgressContainer,
  setRemoveItemsList,
  setSortField,
  setSortOrder,
  registerActiveUpload,
  removeActiveUpload
} = fileManagerSlice.actions;

export default fileManagerSlice.reducer;
